import { render, staticRenderFns } from "./wallet-detail.vue?vue&type=template&id=08b681fc&scoped=true&"
import script from "./wallet-detail.vue?vue&type=script&lang=js&"
export * from "./wallet-detail.vue?vue&type=script&lang=js&"
import style0 from "./wallet-detail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./wallet-detail.vue?vue&type=style&index=1&id=08b681fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b681fc",
  null
  
)

export default component.exports